import {useState} from 'react'
import {Button} from '@primer/react-brand'
import {LinkIcon} from '@primer/octicons-react'
import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {t} from '@github-ui/swp-core/lib/utils/localization'

import Styles from './ShareButton.module.css'

type Props = {
  id: string
  location: string
}

export function ShareButton(props: Props) {
  const {id, location} = props
  const [copied, setCopied] = useState(false)
  const href = `/events/universe/recap/#${id}`

  const copy = {
    label: {
      share: t('Share'),
      copied: t('Link to section copied!'),
    },
    ariaLabel: {
      share: t('Share this section'),
      copied: t('Link to section copied!'),
    },
  }

  const handleClick = async () => {
    try {
      const fullUrl = `${window.location.origin}${href}`
      await navigator.clipboard.writeText(fullUrl)
      setCopied(true)
      setTimeout(() => {
        setCopied(false)
      }, 3000)
    } catch {
      // Silently fail - clipboard write may be blocked by browser permissions
    }
  }

  return (
    <>
      <Button
        className={Styles.ShareButton}
        as="button"
        onClick={handleClick}
        variant="subtle"
        size="small"
        leadingVisual={<LinkIcon />}
        aria-label={copied ? copy.ariaLabel.copied : copy.ariaLabel.share}
        {...getAnalyticsEvent({
          action: copy.label.share,
          tag: 'button',
          context: 'share_button',
          location,
        })}
      >
        <span className={Styles.Text}>{copied ? copy.label.copied : copy.label.share}</span>
      </Button>

      {/* Live region for assistive technology announcements */}
      <div role="status" aria-live="polite" className="sr-only">
        {copied ? copy.ariaLabel.copied : ''}
      </div>
    </>
  )
}
